// @ts-nocheck

import React, { useState, Fragment, useEffect, useCallback } from "react";
import { Menu, Transition } from "@headlessui/react";
import { MenuItem, MenuItems, MenuButton } from "@headlessui/react";
import { Link, useParams } from "react-router-dom";
import { Toaster, toast } from "sonner";
import { useAppDispatch } from "../../app/hooks";
import { fetchPipelineDetailsData } from "../../features/scorecard/scoreCardSlice";
import {
  deleteLocation,
  fetchPipelineStagesList,
} from "../../features/skills/skillsSlice";
import { CustomCheckIcon, ExclamationIcon, SearchIcon } from "../icons";
import { UserDetails } from "../../features/auth/authTypes";
import CreateScoreCardSkill from "./CreateScoreCardSkill";

const colorList = [
  { name: "bg-blue-500" },
  { name: "bg-gray-500" },
  { name: "bg-blue-200" },
  { name: "bg-pink-500" },
  { name: "bg-indigo-500" },
  { name: "bg-yellow-500" },
  { name: "bg-green-500" },
  { name: "bg-cyan-500" },
  { name: "bg-red-600" },
];

function classNames(...classes: any) {
  return classes.filter(Boolean).join(" ");
}

type ChannelProps = {
  userDetails: UserDetails | null;
};

const ScoreCardSkill: React.FC<ChannelProps> = React.memo(({}) => {
  const [editInput, setEditInput] = useState<string | null>(null);
  const [labelName, setLabelName] = useState("");
  const [color, setColor] = useState("bg-gray-500");
  const [newGroup, setNewGroup] = useState(false);
  const [itemTagBaseId, setItemTagBaseId] = useState<any>([]);

  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [isDragActive, setIsDragActive] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);
  const { userId } = useParams<{ userId: string }>();
  const baseIdString =
    localStorage.getItem("UserBaseId") || localStorage.getItem("createBaseId");
  const baseId = baseIdString ? JSON.parse(baseIdString) : null;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editBoardData, setEditBoardData] = useState<{
    id: number;
    baseId: number;
  } | null>(null);
  const [boardsFetched, setBoardsFetched] = useState<any[]>([]);
  const [dataLoading1, setDataLoading1] = useState(false);
  const dispatch = useAppDispatch();
  const { jobId } = useParams<{ jobId: string }>();

  const handleSearchChange = (e: any) => {
    setSearchQuery(e.target.value);
  };

  const handleCancel = () => {
    setEditInput(null);
    setNewGroup(false);
    // setNewLabel(false)
  };

  const openModal = () => {
    setEditBoardData(null);
    setIsModalOpen(true);
  };

  useEffect(() => {
    const fetchPipelineDetails = async () => {
      if (!baseId || !userId) return;

      // Retrieve basePipelineData from local storage
      const localDataString = localStorage.getItem("baseScoreCardDataByJob");
      const localData = localDataString ? JSON.parse(localDataString) : null;

      if (localData && localData.data) {
        // Check if the pipeline ID matches the userId
        const pipeline = localData.data.find((p) => p.id === userId);
        if (pipeline) {
          setItemTagBaseId(pipeline);
          return;
        } else {
          console.error("Pipeline not found in local storage");
        }
      }

      // If data is not found in local storage, make the API call
      setDataLoading(true);
      try {
        const baseResponse = await dispatch(
          fetchPipelineDetailsData({ baseId: Number(baseId), userId }),
        );

        if (fetchPipelineDetailsData.fulfilled.match(baseResponse)) {
          // Handle successful response
          const fetchedData = baseResponse.payload.data;

          // Set the state with the fetched data
          setItemTagBaseId(fetchedData);

          // Optionally save fetched data to local storage
          localStorage.setItem(
            "baseScoreCardDataByJob",
            JSON.stringify(baseResponse.payload),
          );
        } else {
          // Handle error
          console.error(
            "Error fetching pipeline details:",
            baseResponse.payload,
          );
          setItemTagBaseId([]);
        }
      } catch (error) {
        console.error("Error fetching pipeline details:", error);
        setItemTagBaseId([]);
      } finally {
        setDataLoading(false);
      }
    };

    fetchPipelineDetails();
  }, [baseId, dispatch, userId]);

  useEffect(() => {
    const fetchTeams = async () => {
      if (!baseId || !userId) return;

      setDataLoading1(true);
      try {
        const baseResponse = await dispatch(
          fetchPipelineStagesList({ baseId: Number(baseId), userId }),
        );

        if (fetchPipelineStagesList.fulfilled.match(baseResponse)) {
          // Handle successful response
          setBoardsFetched(baseResponse.payload.data);
          localStorage.setItem(
            "baseSkillsData",
            JSON.stringify(baseResponse.payload),
          );
        } else {
          // Handle error
          console.error(
            "Error fetching pipeline details:",
            baseResponse.payload,
          );
          setBoardsFetched([]);
        }
      } catch (error) {
        console.error("Error fetching pipeline details:", error);
        setBoardsFetched([]);
      } finally {
        setDataLoading1(false);
      }
    };

    fetchTeams();
  }, [baseId, dispatch, userId]);

  const handleItemTagsDelete = async (itemId: number) => {
    if (!baseId) {
      toast.error("Base ID is not available");
      return;
    }

    try {
      const resultAction = await dispatch(
        deleteLocation({ baseId: parseInt(baseId), id: itemId }),
      );

      if (deleteLocation.fulfilled.match(resultAction)) {
        toast.success("Item deleted successfully");
        // Refresh the list after deletion
        const res = await dispatch(
          fetchPipelineStagesList({ baseId: parseInt(baseId), userId }),
        );

        if (fetchPipelineStagesList.fulfilled.match(res)) {
          if (res.payload) {
            localStorage.setItem("baseSkillsData", JSON.stringify(res.payload));
            window.dispatchEvent(
              new StorageEvent("storage", {
                key: "baseSkillsData",
                newValue: JSON.stringify(res.payload),
              }),
            );
          }
        } else if (fetchPipelineStagesList.rejected.match(res)) {
          toast.error("Failed to refresh the pipeline stages list");
        }
      } else if (deleteLocation.rejected.match(resultAction)) {
        const error = resultAction.payload;
        toast.error(error || "Failed to delete item");
      }
    } catch (error) {
      console.error("Error deleting item:", error);
      toast.error("An error occurred while deleting the item");
    }
  };

  const handleUpdateSave = async () => {};

  useEffect(() => {
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === "baseSkillsData" && e.newValue) {
        const teamsDataArray = JSON.parse(e.newValue);
        setBoardsFetched(teamsDataArray.data || []);
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  const handleEdit = useCallback(
    (id: number, baseId: number) => {
      const teamToEdit = boardsFetched.find((team) => team.id === id);
      if (teamToEdit) {
        setEditBoardData(teamToEdit);
        setIsModalOpen(true);
      }
    },
    [boardsFetched],
  );

  return (
    <>
      <Toaster richColors />
      <div className="flex justify-end gap-x-2">
        <div className=""></div>
      </div>
      <main className="py-[34px] lg:py-[70px] px-0 lg:px-10 h-full flex">
        <div className="px-[2px] sm:px-6 lg:px-8 w-full flex justify-center">
          <div className="w-full max-w-[640px]">
            <Link
              to={`/${baseId}/job/${jobId}/manage/scorecard`}
              className=" flex items-center gap-x-1 w-full mb-4"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="icon icon-tabler icons-tabler-outline icon-tabler-chevron-left w-[0.9rem] h-[0.9rem]"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M15 6l-6 6l6 6" />
              </svg>
              <span className="text-black-100 text-[13px]">
                Back to listing
              </span>
              {/* <ArrowLeftIcon /> */}
            </Link>

            <div className="flex flex-col gap-y-1 w-full">
              <h2 className="text-[20px] lg:text-[24px] font-medium leading-8 text-[#1b1b1b] tracking-[-0.01rem]">
                {itemTagBaseId.scorecard_name}
              </h2>
              <p className="text-sm leading-5 text-[#5c5c5e] font-medium">
                {itemTagBaseId.scorecard_description}
              </p>
            </div>
            <div className="bg-[#e0e0e0] w-full h-[1px] my-6"></div>
            <div className=" mt-6 lg:mt-10 flex items-center  w-full gap-x-3 mb-5">
              <div className="w-full lg:w-[40%]">
                <div className="relative items-center w-full">
                  <input
                    type="text"
                    //   value={searchVal}
                    //   onChange={(e) => setSearchVal((e.target as HTMLInputElement).value)}
                    value={searchQuery}
                    onChange={handleSearchChange}
                    name="search"
                    id="search"
                    placeholder="Search name and email"
                    className="flex w-full grow border px-4 py-2 pl-8 text-sm leading-6 shadow-[0 1px 2px 0 rgba(18, 18, 23, 0.05)] transition-colors duration-100 placeholder:text-surface-500 outline-indigo-600
                  focus:outline focus:outline-2 focus:-outline-offset-2 bg-background text-text-100 hover:border-[#a9a9bc] dark:hover:border-surface-200
                  border-[#d1d1db] dark:border-surface-100 focus:outline-indigo-600 h-[36px] rounded-[0.375rem]"
                  />
                  <div className="absolute inset-y-0 left-0 flex py-1.5 pr-1.5">
                    <SearchIcon />
                  </div>
                </div>
              </div>

              <div className="w-full lg:w-[60%]">
                <div className="flex justify-end">
                  <div className="">
                    <button
                      type="button"
                      onClick={openModal}
                      className=" inline-flex shrink-0  justify-center rounded-md bg-indigo-600 px-[14px] py-1 text-[13px] font-medium h-[32px] leading-6 text-white shadow-sm hover:bg-indigo-500 
                      focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                    >
                      Create Skill
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {dataLoading1 ? (
              <div
                className="flex items-center justify-center relative z-50"
                style={{ height: "calc(100vh - 191px)" }}
              >
                <div className="simple-spinner-loader">
                  <span></span>
                </div>
              </div>
            ) : (
              <div>
                <div className="flex flex-col gap-y-2">
                  {newGroup && (
                    <div className="bg-[#edeef2] p-2 border border-solid border-[#e0e0e0] rounded mb-1">
                      <div className="w-full">
                        <form>
                          <div className="flex flex-row items-center gap-2 flex-1">
                            {/* <div className='px-2 flex items-center justify-center cursor-pointer h-[32px] w-[32px] bg-white border border-solid border-[#d8d8d86] rounded-md text-sm'> */}

                            <Menu
                              as="div"
                              className="relative flex items-center "
                            >
                              <Menu.Button className="">
                                <span className="sr-only">Open user menu</span>
                                <div className="px-2 flex items-center justify-center cursor-pointer h-[32px] w-[32px] bg-white border border-solid border-[#d8d8d86] rounded-md text-sm">
                                  <div
                                    className={`border-0 bg-none text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm w-[9px] h-[9px] rounded-full ${color} border flex justify-center items-center`}
                                  ></div>
                                </div>
                              </Menu.Button>
                              <Transition
                                as={Fragment}
                                enter="transition ease-out duration-100"
                                enterFrom="transform opacity-0 scale-95"
                                enterTo="transform opacity-100 scale-100"
                                leave="transition ease-in duration-75"
                                leaveFrom="transform opacity-100 scale-100"
                                leaveTo="transform opacity-0 scale-95"
                              >
                                <Menu.Items className="absolute flex flex-wrap left-0 top-8 z-10 mt-2.5 w-44 p-2 origin-top-right rounded-md bg-white py-2 shadow-lg ring-1 ring-gray-900/5 focus:outline-none">
                                  {colorList.map((value: any, index) => {
                                    return (
                                      <div
                                        onClick={() => setColor(value.name)}
                                        key={index}
                                        className={`flex h-6 w-6 border ${value.name} rounded-full m-2 justify-center items-center`}
                                      >
                                        {color === value.name ? (
                                          <CustomCheckIcon />
                                        ) : null}
                                      </div>
                                    );
                                  })}
                                </Menu.Items>
                              </Transition>
                            </Menu>
                            <div className="w-full">
                              <input
                                name="text"
                                type="text"
                                required
                                value={labelName}
                                onChange={(e) => setLabelName(e.target.value)}
                                placeholder="Enter Purpose"
                                // req
                                className="flex w-full grow border px-4 py-2 pl-8 text-sm leading-6 shadow-[0 1px 2px 0 rgba(18, 18, 23, 0.05)] transition-colors duration-100 placeholder:text-surface-500 outline-indigo-600
                  focus:outline focus:outline-2 focus:-outline-offset-2 bg-background text-text-100 hover:border-[#a9a9bc] dark:hover:border-surface-200
                  border-[#d1d1db] dark:border-surface-100 focus:outline-indigo-600 h-[36px] rounded-[0.375rem]"
                              />
                            </div>
                            <span className="bg-[#e3e3e3] w-[1px] h-[30px]"></span>
                            <div className="flex items-center gap-x-2 flex-1">
                              <button
                                className=" inline-flex shrink-0  justify-center rounded-md bg-indigo-600  items-center px-[14px] py-1 text-[13px] font-medium h-[32px] leading-6 text-white shadow-sm hover:bg-indigo-500 
                                focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                                type="button"

                                // onClick={handleCancel}
                              >
                                Cancel
                              </button>
                              <button
                                // onClick={handleSave}
                                type="button"
                                className={`inline-flex shrink-0  justify-center rounded-md bg-indigo-600 items-center px-[14px] py-1 text-[13px] font-medium h-[32px] leading-6 text-white shadow-sm hover:bg-indigo-500 
                                focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600
                           [&>span]:flex [&>span]:items-center [&>span]:gap-[8px] ${
                             !labelName && "opacity-50 cursor-not-allowed"
                           }`}
                                disabled={!labelName}
                              >
                                Save
                                {loading && (
                                  <div className="simple-spinner">
                                    <span></span>
                                  </div>
                                )}
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  )}

                  {boardsFetched.length === 0 ? (
                    <div className="w-full mt-5 flex h-[300px] justify-center items-center flex-col gap-y-3">
                      <ExclamationIcon />
                      <p className="text-[#0000007a] text-[13px]">
                        No results found
                      </p>
                    </div>
                  ) : (
                    <>
                      {!isDragActive &&
                        boardsFetched
                          ?.filter((item) =>
                            item.skill_name
                              .toLowerCase()
                              .includes(searchQuery.toLowerCase()),
                          )
                          .map((item: any, index) => (
                            <div
                              key={index}
                              className="p-2 rounded-[0.375rem] bg-white border border-solid border-[#e3e3e3] mb-1 relative pl-4 feedback-tags-hover last-of-type:mb-[70px]"
                            >
                              {editInput === item.id ? (
                                <div className="w-full">
                                  <form>
                                    <div className="flex flex-row items-center gap-2 flex-1">
                                      <Menu
                                        as="div"
                                        className="relative flex items-center "
                                      >
                                        <Menu.Button className="">
                                          <span className="sr-only">
                                            Open user menu
                                          </span>
                                          <div className="px-2 flex items-center justify-center cursor-pointer h-[32px] w-[32px] bg-white border border-solid border-[#d8d8d86] rounded-md text-sm">
                                            <div
                                              className={`border-0 bg-none text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm w-[9px] h-[9px] rounded-full ${color} border flex justify-center items-center`}
                                            ></div>
                                          </div>
                                        </Menu.Button>
                                        <Transition
                                          as={Fragment}
                                          enter="transition ease-out duration-100"
                                          enterFrom="transform opacity-0 scale-95"
                                          enterTo="transform opacity-100 scale-100"
                                          leave="transition ease-in duration-75"
                                          leaveFrom="transform opacity-100 scale-100"
                                          leaveTo="transform opacity-0 scale-95"
                                        >
                                          <Menu.Items className="absolute flex flex-wrap left-0 top-8 z-10 mt-2.5 w-44 p-2 origin-top-right rounded-md bg-white py-2 shadow-lg ring-1 ring-gray-900/5 focus:outline-none">
                                            {colorList.map(
                                              (value: any, index) => {
                                                return (
                                                  <div
                                                    onClick={() =>
                                                      setColor(value.name)
                                                    }
                                                    key={index}
                                                    className={`flex h-6 w-6 border ${value.name} rounded-full m-2 justify-center items-center`}
                                                  >
                                                    {color === value.name ? (
                                                      <CustomCheckIcon />
                                                    ) : null}
                                                  </div>
                                                );
                                              },
                                            )}
                                          </Menu.Items>
                                        </Transition>
                                      </Menu>
                                      <div className="w-full">
                                        <input
                                          name="text"
                                          type="text"
                                          required
                                          value={labelName}
                                          onChange={(e) =>
                                            setLabelName(e.target.value)
                                          }
                                          placeholder="Enter Purpose"
                                          className="flex w-full grow border px-4 py-2 pl-8 text-sm leading-6 shadow-[0 1px 2px 0 rgba(18, 18, 23, 0.05)] transition-colors duration-100 placeholder:text-surface-500 outline-indigo-600
                                            focus:outline focus:outline-2 focus:-outline-offset-2 bg-background text-text-100 hover:border-[#a9a9bc] dark:hover:border-surface-200
                                            border-[#d1d1db] dark:border-surface-100 focus:outline-indigo-600 h-[36px] rounded-[0.375rem]"
                                        />
                                      </div>
                                      <span className="bg-[#e3e3e3] w-[1px] h-[30px]"></span>
                                      <div className="flex items-center gap-x-2 flex-1">
                                        <button
                                          // onClick={() => navigate(`/${baseId}/create/project`)}
                                          type="button"
                                          variant="outline"
                                          onClick={handleCancel}
                                          className=" inline-flex shrink-0  justify-center rounded-md bg-indigo-600 items-center px-[14px] py-1 text-[13px] font-medium h-[32px] leading-6 text-white shadow-sm hover:bg-indigo-500 
                                            focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                                        >
                                          Cancel
                                        </button>
                                        <button
                                          // onClick={() => navigate(`/${baseId}/create/project`)}
                                          onClick={handleUpdateSave}
                                          type="button"
                                          className={`bg-indigo-600 hover:bg-indigo-500 focus-visible:outline-indigo-600 relative
                                         [&>span]:flex [&>span]:items-center [&>span]:gap-[8px] ${
                                           !labelName &&
                                           "opacity-50 cursor-not-allowed"
                                         }`}
                                          disabled={!labelName} // Disable button when labelName is falsy
                                          className=" inline-flex shrink-0  justify-center rounded-md bg-indigo-600 items-center px-[14px] py-1 text-[13px] font-medium h-[32px] leading-6 text-white shadow-sm hover:bg-indigo-500 
                                            focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                                        >
                                          Save
                                          {loading && (
                                            <div className="simple-spinner">
                                              <span></span>
                                            </div>
                                          )}
                                        </button>
                                      </div>
                                    </div>
                                  </form>
                                </div>
                              ) : (
                                <>
                                  <div className="flex flex-row items-start justify-between flex-grow shrink-0">
                                    <div className="flex items-start gap-x-[16px]">
                                      <div
                                        className={` shrink-0 w-[9px] mt-[5px] mt h-[9px] rounded-full bg-[${item.skill_colour}]`}
                                      ></div>
                                      <div className="flex flex-col gap-y-[2px]">
                                        <span className="flex-shrink whitespace-nowrap overflow-hidden text-ellipsis font-medium text-[#1b1b1b] text-sm leading-5">
                                          {item.skill_name}
                                        </span>
                                        {item.detail && (
                                          <p className="text-[12px] text-[#5c5c5e] font-normal leading-5 capitalize mt-[0px]">
                                            {item.detail}
                                          </p>
                                        )}
                                      </div>

                                      <div className=" cursor-default select-none flex flex-row"></div>
                                    </div>
                                    <div className="mr-[0px] flex  flex-row items-center flex-grow-0">
                                      <div className="flex flex-row gap-[8px] items-center">
                                        {item.skill_scale && (
                                          <>
                                            {item.skill_scale === 1 && (
                                              <span className="inline-flex items-center rounded-md bg-blue-50 px-2 py-1 text-xs font-medium text-blue-700 ring-1 ring-inset ring-blue-700/10">
                                                Basic
                                              </span>
                                            )}
                                            {item.skill_scale === 2 && (
                                              <span className="inline-flex items-center rounded-md bg-blue-50 px-2 py-1 text-xs font-medium text-blue-700 ring-1 ring-inset ring-blue-700/10">
                                                Intermediate
                                              </span>
                                            )}
                                            {item.skill_scale === 3 && (
                                              <span className="inline-flex items-center rounded-md bg-blue-50 px-2 py-1 text-xs font-medium text-blue-700 ring-1 ring-inset ring-blue-700/10">
                                                Advanced
                                              </span>
                                            )}
                                            {item.skill_scale === 4 && (
                                              <span className="inline-flex items-center rounded-md bg-blue-50 px-2 py-1 text-xs font-medium text-blue-700 ring-1 ring-inset ring-blue-700/10">
                                                Expert
                                              </span>
                                            )}
                                            {item.skill_scale === 5 && (
                                              <span className="inline-flex items-center rounded-md bg-blue-50 px-2 py-1 text-xs font-medium text-blue-700 ring-1 ring-inset ring-blue-700/10">
                                                Expert
                                              </span>
                                            )}
                                          </>
                                        )}
                                        {item?.comment_required === true && (
                                          <span className="inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20">
                                            <div
                                              data-title="Comment required"
                                              className="table-tooltip h-full flex items-center"
                                            >
                                              <button className="">
                                                <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  width={24}
                                                  height={24}
                                                  viewBox="0 0 24 24"
                                                  fill="none"
                                                  stroke="#15803d"
                                                  strokeWidth={2}
                                                  strokeLinecap="round"
                                                  strokeLinejoin="round"
                                                  className="icon icon-tabler icons-tabler-outline icon-tabler-message-report w-[14px] h-[1rem] text-green-700"
                                                >
                                                  <path
                                                    stroke="none"
                                                    d="M0 0h24v24H0z"
                                                    fill="none"
                                                  />
                                                  <path d="M18 4a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-5l-5 3v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12z" />
                                                  <path d="M12 8v3" />
                                                  <path d="M12 14v.01" />
                                                </svg>
                                              </button>
                                            </div>
                                          </span>
                                        )}
                                        {item?.comment_required === false && (
                                          <span className="inline-flex items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10">
                                            <div
                                              data-title="Comment not required"
                                              className="table-tooltip h-full flex items-center"
                                            >
                                              <button className="">
                                                <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  width={24}
                                                  height={24}
                                                  viewBox="0 0 24 24"
                                                  fill="none"
                                                  stroke="#4b5563"
                                                  strokeWidth={2}
                                                  strokeLinecap="round"
                                                  strokeLinejoin="round"
                                                  className="icon icon-tabler icons-tabler-outline icon-tabler-message-report w-[14px] h-[1rem] text-gray-600"
                                                >
                                                  <path
                                                    stroke="none"
                                                    d="M0 0h24v24H0z"
                                                    fill="none"
                                                  />
                                                  <path d="M18 4a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-5l-5 3v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12z" />
                                                  <path d="M12 8v3" />
                                                  <path d="M12 14v.01" />
                                                </svg>
                                              </button>
                                            </div>
                                          </span>
                                        )}
                                        <div
                                          data-title="Edit"
                                          className="table-tooltip h-full flex items-center"
                                        >
                                          <button className="feedback-edit-btn-hover">
                                            <svg
                                              onClick={() =>
                                                handleEdit(
                                                  item.id,
                                                  item.base_id,
                                                )
                                              }
                                              xmlns="http://www.w3.org/2000/svg"
                                              width={24}
                                              height={24}
                                              viewBox="0 0 24 24"
                                              fill="none"
                                              stroke="#0000007a"
                                              strokeWidth={2}
                                              strokeLinecap="round"
                                              strokeLinejoin="round"
                                              className="icon icon-tabler icons-tabler-outline icon-tabler-pencil w-[1rem] h-[1rem] text-[#0000007a]"
                                            >
                                              <path
                                                stroke="none"
                                                d="M0 0h24v24H0z"
                                                fill="none"
                                              />
                                              <path d="M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4" />
                                              <path d="M13.5 6.5l4 4" />
                                            </svg>
                                          </button>
                                        </div>
                                        <button className="feedback-more-btn-hover">
                                          <Menu
                                            as="div"
                                            className="relative inline-block text-left"
                                          >
                                            <div>
                                              <MenuButton className="rounded-md flex items-center justify-center">
                                                <span className="sr-only">
                                                  Open options
                                                </span>
                                                <svg
                                                  stroke="currentColor"
                                                  fill="#a0a0a2"
                                                  className="text-[#a0a0a2]"
                                                  strokeWidth="2"
                                                  viewBox="0 0 24 24"
                                                  strokeLinecap="round"
                                                  strokeLinejoin="round"
                                                  aria-hidden="true"
                                                  focusable="false"
                                                  height="1em"
                                                  width="1em"
                                                  xmlns="http://www.w3.org/2000/svg"
                                                >
                                                  <circle
                                                    cx="12"
                                                    cy="12"
                                                    r="1"
                                                  ></circle>
                                                  <circle
                                                    cx="12"
                                                    cy="5"
                                                    r="1"
                                                  ></circle>
                                                  <circle
                                                    cx="12"
                                                    cy="19"
                                                    r="1"
                                                  ></circle>
                                                </svg>
                                              </MenuButton>
                                            </div>

                                            <Transition
                                              enter="transition ease-out duration-100"
                                              enterFrom="transform opacity-0 scale-95"
                                              enterTo="transform opacity-100 scale-100"
                                              leave="transition ease-in duration-75"
                                              leaveFrom="transform opacity-100 scale-100"
                                              leaveTo="transform opacity-0 scale-95"
                                            >
                                              <MenuItems className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white  shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                                                <div className="py-1">
                                                  <MenuItem>
                                                    {({ focus }) => (
                                                      <Link
                                                        to="#"
                                                        className={classNames(
                                                          focus
                                                            ? "bg-gray-100 text-gray-900"
                                                            : "text-gray-700",
                                                          "block px-4 py-2 text-sm",
                                                        )}
                                                        onClick={() =>
                                                          handleItemTagsDelete(
                                                            item.id,
                                                          )
                                                        }
                                                      >
                                                        Delete
                                                      </Link>
                                                    )}
                                                  </MenuItem>
                                                </div>
                                              </MenuItems>
                                            </Transition>
                                          </Menu>
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </>
                              )}
                            </div>
                          ))}
                    </>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </main>

      <CreateScoreCardSkill
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        editBoardData={editBoardData}
        baseId={baseId}
        setEditBoardData={setEditBoardData}
        userId={userId}
      />
    </>
  );
});

export default ScoreCardSkill;
